import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://csikeiifvjnlggmawhnc.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNzaWtlaWlmdmpubGdnbWF3aG5jIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzU3MzI4NzYsImV4cCI6MjA5MTMwODg3Nn0.pt9_vnUiJxwkRjDxkCVwdECaWIvKG5QxYOENPwKRU9s';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
